/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:f58bc965-4c37-4512-b304-ff09cd9149c6",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_g81u5jAbC",
    "aws_user_pools_web_client_id": "5h2hgvgusav5rh0bnaal546223",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://pamlyrpaijesxoua36pi6ugybe.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-u5ozqdiizrbe3mdeq755xgrwbu",
    "aws_mobile_analytics_app_id": "64674d7de2874679a8c70290636adc65",
    "aws_mobile_analytics_app_region": "eu-west-1",
    "aws_user_files_s3_bucket": "hyperaudio-conferences-storage-staging71837-nmf",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "predictions": {
        "convert": {
            "translateText": {
                "region": "eu-west-1",
                "proxy": false,
                "defaults": {
                    "sourceLanguage": "en",
                    "targetLanguage": "es"
                }
            },
            "transcription": {
                "region": "eu-west-1",
                "proxy": false,
                "defaults": {
                    "language": "en-US"
                }
            }
        }
    }
};


export default awsmobile;
